"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * eXtend Media Paywall Service API
 * Media Wall API Specification
 *
 * The version of the OpenAPI document: v1
 * Contact: t.ioannidis@extend.gr
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
 * The ColleagueInvitationItem model module.
 * @module model/ColleagueInvitationItem
 * @version 1.1.3-alpha.1
 */
class ColleagueInvitationItem {
  /**
   * Constructs a new <code>ColleagueInvitationItem</code>.
   * @alias module:model/ColleagueInvitationItem
   * @param name {String} 
   * @param last_name {String} 
   * @param email {String} 
   */
  constructor(name, last_name, email) {
    ColleagueInvitationItem.initialize(this, name, last_name, email);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  static initialize(obj, name, last_name, email) {
    obj['name'] = name;
    obj['last_name'] = last_name;
    obj['email'] = email;
  }

  /**
   * Constructs a <code>ColleagueInvitationItem</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ColleagueInvitationItem} obj Optional instance to populate.
   * @return {module:model/ColleagueInvitationItem} The populated <code>ColleagueInvitationItem</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new ColleagueInvitationItem();
      if (data.hasOwnProperty('name')) {
        obj['name'] = _ApiClient.default.convertToType(data['name'], 'String');
      }
      if (data.hasOwnProperty('last_name')) {
        obj['last_name'] = _ApiClient.default.convertToType(data['last_name'], 'String');
      }
      if (data.hasOwnProperty('email')) {
        obj['email'] = _ApiClient.default.convertToType(data['email'], 'String');
      }
    }
    return obj;
  }

  /**
   * Validates the JSON data with respect to <code>ColleagueInvitationItem</code>.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @return {boolean} to indicate whether the JSON data is valid with respect to <code>ColleagueInvitationItem</code>.
   */
  static validateJSON(data) {
    // check to make sure all required properties are present in the JSON string
    for (const property of ColleagueInvitationItem.RequiredProperties) {
      if (!data[property]) {
        throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
      }
    }
    // ensure the json data is a string
    if (data['name'] && !(typeof data['name'] === 'string' || data['name'] instanceof String)) {
      throw new Error("Expected the field `name` to be a primitive type in the JSON string but got " + data['name']);
    }
    // ensure the json data is a string
    if (data['last_name'] && !(typeof data['last_name'] === 'string' || data['last_name'] instanceof String)) {
      throw new Error("Expected the field `last_name` to be a primitive type in the JSON string but got " + data['last_name']);
    }
    // ensure the json data is a string
    if (data['email'] && !(typeof data['email'] === 'string' || data['email'] instanceof String)) {
      throw new Error("Expected the field `email` to be a primitive type in the JSON string but got " + data['email']);
    }
    return true;
  }
}
ColleagueInvitationItem.RequiredProperties = ["name", "last_name", "email"];

/**
 * @member {String} name
 */
ColleagueInvitationItem.prototype['name'] = undefined;

/**
 * @member {String} last_name
 */
ColleagueInvitationItem.prototype['last_name'] = undefined;

/**
 * @member {String} email
 */
ColleagueInvitationItem.prototype['email'] = undefined;
var _default = exports.default = ColleagueInvitationItem;